export { default } from "./IconWithBadge";
